import { isSupabaseConfigured, supabase } from "@/lib/supabase";

export interface ContactLeadInput {
  nombre: string;
  telefono: string;
  email: string;
  interes: string;
  mensaje: string;
  source?: string;
}

export async function createContactLead(input: ContactLeadInput) {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error("Supabase no esta configurado para recibir solicitudes.");
  }

  const { error } = await supabase.from("contact_leads").insert({
    nombre: input.nombre,
    telefono: input.telefono || null,
    email: input.email,
    interes: input.interes,
    mensaje: input.mensaje || null,
    source: input.source ?? "website",
    status: "new",
  });

  if (error) throw error;
}
